module.exports = __webpack_public_path__ + "img/schedule-visit-th.f4f0c98.png";